import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../context/DataContext';
import { getImageFileName, dataURItoBlob } from '../utils';

const SignAgreementPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const { state, uploadInsurePic } = React.useContext(Context);
  const sigPad = React.useRef(null);
  const {
    customerInfo: { orderId },
  } = state;

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2 }}>
        投保須知條款確認簽名
      </Typography>
      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            borderWidth: 1,
            borderRadius: 2,
            borderColor: 'rgba(0,0,0,0.23)',
            borderStyle: 'solid',
            mb: 2,
          }}
        >
          <SignatureCanvas
            ref={sigPad}
            canvasProps={{
              style: { width: '100%', height: 168, display: 'block' },
            }}
          />
        </Box>
        {errorMsg ? (
          <Typography variant="h6" sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
          <Button
            color="secondary"
            variant="contained"
            sx={{ width: 128 }}
            onClick={() => {
              // clear signature
              sigPad.current.clear();
            }}
          >
            重簽
          </Button>
          <LoadingButton
            variant="contained"
            sx={{ width: 128 }}
            loading={loading}
            onClick={() => {
              // var blobUrl = URL.createObjectURL(
              //   dataURItoBlob(sigPad.current.getCanvas().toDataURL('image/png'))
              // );
              // var a = document.createElement('a');
              // a.setAttribute('download', 'test.png');
              // a.setAttribute('href', blobUrl);
              // document.body.appendChild(a);
              // a.click();
              // document.body.removeChild(a);
              // URL.revokeObjectURL(blobUrl);
              if (errorMsg) setErrorMsg('');

              if (sigPad.current.isEmpty()) {
                setErrorMsg('請簽名');
              } else {
                setLoading(true);
                // save signature
                const picName = getImageFileName() + '.png';
                uploadInsurePic(
                  {
                    orderId,
                    picType: 'termsign',
                    picFile: new File(
                      [
                        dataURItoBlob(
                          sigPad.current.getCanvas().toDataURL('image/png')
                        ),
                      ],
                      picName
                    ),
                    picName,
                    picUrl: '',
                  },
                  (data) => {
                    const { responseCode, responseMsg } = data;
                    setLoading(false);

                    if (responseCode === '000') {
                      navigate('/client-info');
                    } else {
                      setErrorMsg(responseMsg);
                    }
                  }
                );
              }
            }}
          >
            下一步
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
};

export default SignAgreementPage;
